import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getOidcConfigurationByCustomer } from '@api';

export const securityOidcConfigurationsByCustomerIdByIdGetSlice = createGetAsyncSlice({
	name: 'SecurityOidcConfigurationsByCustomerById',
	receive: true,
	request: true,
	requestHandler: getOidcConfigurationByCustomer,
	retainDataOnRequest: true
});
